import React, { useEffect } from 'react';
import { object, bool } from 'prop-types';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import {
    CAROUSEL_CONTEXT,
    RECOMMENDED_IN_SUBCATEGORY_FROM_EXTERNAL_VISITS
} from '../../utils/carousels';
import { TOP } from '../shared/GigCardCarouselWrapper/config';
import { MP_VIEWED_RECOMMENDED_IN_SC_FROM_EXTERNAL_VISITS_CAROUSEL } from '../../utils/mixPanelEvents';

export const SOURCE = 'recommended_in_sc_from_external_visits';
export const PRO_SOURCE = 'recommended_in_pro_sc_from_external_visits';

const RecommendedInScFromExternalVisits = ({
    isTouch,
    isLoggedIn,
    shouldFetchCarousel = true
}, {
    general,
    pathfinderWrapper,
    biEvents
}) => {

    const getSource = () => general.isPro ? PRO_SOURCE : SOURCE;

    const { gigId, isPro } = general;
    const { queryParameters } = getContext();
    const { ref } = queryParameters;

    const url = pathfinderWrapper.pathfinder('gig_page_fetch_recommendations_by_type',
        { type: 'by_gig_views' },
        { query: { gig_id: gigId, pro_only: isPro.toString(), ref } });

    useEffect(() => {
        biEvents.sendMixPanelEvent({
            eventName: MP_VIEWED_RECOMMENDED_IN_SC_FROM_EXTERNAL_VISITS_CAROUSEL,
            params: { 'Source component': 'Gig page' }
        });
    }, [biEvents]);

    return (
        <GigCardCarouselWrapper boxTitle={<I18n k="gig_page_perseus.recommended_gigs.people_also_viewed_sentence_case.title"/>}
            boxClass="gigs-recommended-in-from-external-visits"
            type={RECOMMENDED_IN_SUBCATEGORY_FROM_EXTERNAL_VISITS}
            url={url}
            carouselPosition={1}
            boxLocation={TOP}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            source={getSource()}
            carouselContext={CAROUSEL_CONTEXT}
            shouldFetchCarousel={shouldFetchCarousel}
            features={{
                gigInNewTab: true
            }}/>
    );
};

RecommendedInScFromExternalVisits.propTypes = {
    isTouch: bool,
    isLoggedIn: bool,
    shouldFetchCarousel: bool
};

RecommendedInScFromExternalVisits.contextTypes = {
    general: object,
    pathfinderWrapper: object,
    biEvents: object
};

export { RecommendedInScFromExternalVisits };
export default SafePureComponent(RecommendedInScFromExternalVisits);
